import React from "react";
import { Field, Form, Formik } from "formik";
import FormikFormInput from "../../../../shared-components/FormikFormHandlers/FormikFormInput";
import { Button, Modal } from "react-bootstrap";
import { profileValidateSchema } from "../../../../shared-components/FormikFormHandlers/FormikValidationSchema";
import Label from "../../../../shared-components/Label/Label";
import FormikDateFieldMUI from "../../../../shared-components/FormikFormHandlers/FormikDateFieldMUI";
import LoaderButton from "../../../../shared-components/Button/LoaderButton";
import { UserTypeNumber } from "../../../../constants/enum";
import FormikFormCheckBox from "../../../../shared-components/FormikFormHandlers/FormikFormCheckBox";
import { FormattedMessage } from "react-intl";
import { IAddUser } from "../../../../models/Form/IAddUser";

interface IProps {
    modalClosed: () => void;
    isLoading: boolean;
    submitHandler: (data: IAddUser) => void;
    initialValues: IAddUser;
}

const EditProfileForm = (props: IProps) => {
    return (
        <>
        <Modal show={true} centered
            onHide={props.modalClosed}
            backdrop="static"
            scrollable={true}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <FormattedMessage id="edit_profile" />
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    initialValues={props.initialValues}
                    validationSchema={profileValidateSchema}
                    // enableReinitialize
                    validateOnBlur={false}
                    onSubmit={async (values) => {
                        props.submitHandler(values);
                    }}>
                    {({ values, errors, handleChange, handleBlur }) => (
                    <>
                    <Form className="mw-100" id="edit-profile-form">
                        <div className="loginBox">
                            <div className="form-group">
                                <Label
                                    required={true}
                                    label="profile_label_email"
                                    htmlFor="Email"
                                />
                                <Field
                                    disabled={true}
                                    data-testid="Email"
                                    className="form-control"
                                    name="Email"
                                    type="text"
                                    invalidcharacter={[" "]}
                                    placeholder="profile_label_email"
                                    validcharacter={[
                                        "-",
                                        "_",
                                        "[",
                                        "]",
                                        "(",
                                        ")",
                                        ":",
                                        "#",
                                        "@",
                                        ".",
                                    ]}
                                    as={FormikFormInput}
                                />
                            </div>
                            <div className="form-group">
                                <Label
                                    required={true}
                                    label="profile_label_name"
                                    htmlFor="FirstName"
                                />
                                <Field
                                    data-testid="FirstName"
                                    className="form-control"
                                    name="FirstName"
                                    type="text"
                                    invalidcharacter={[" "]}
                                    placeholder="profile_label_name"
                                    as={FormikFormInput}
                                />
                            </div>
                            <div className="form-group">
                                <Label
                                    required={true}
                                    label="profile_label_familyname"
                                    htmlFor="LastName"
                                />
                                <Field
                                    data-testid="LastName"
                                    className="form-control"
                                    name="LastName"
                                    type="text"
                                    invalidcharacter={[" "]}
                                    placeholder="profile_label_familyname"
                                    as={FormikFormInput}
                                />
                            </div>
                            <div className="form-group">
                                <Label
                                    required={true}
                                    label="profile_label_level"
                                    htmlFor="UserType"
                                />
                                <Field
                                    data-testid="UserType"
                                    className="form-control"
                                    name="UserType"
                                    as="select"
                                    invalidcharacter={[" "]}
                                    placeholder="profile_label_level"
                                >
                                    <option value="1">Admin</option>
                                    <option value="2">Free</option>
                                    <option value="3">Trainer</option>
                                </Field>
                            </div>
                            
                            {
                                (values.UserType != UserTypeNumber.Personal) && 
                                    <div className="form-group">
                                        <Label
                                            required={true}
                                            label="profile_label_subscription_expiry"
                                            htmlFor="SubscriptionExpiryDate"
                                        />
                                        <Field
                                            data-testid="SubscriptionExpiryDate"
                                            className="form-control"
                                            name="SubscriptionExpiryDate"
                                            min={Date.now()}
                                            placeholder="profile_label_subscription_expiry"
                                            as={FormikDateFieldMUI}
                                        />
                                    </div>
                            }
                            {
                                (values.UserType == UserTypeNumber.Trainer || values.UserType == UserTypeNumber.Admin) && 
                                    <div className="form-group">
                                        <Label
                                            required={true}
                                            label="profile_label_trainer_invitations_available"
                                            htmlFor="TrainerInvitesAvailable"
                                        />
                                        <Field
                                            data-testid="TrainerInvitesAvailable"
                                            className="form-control"
                                            name="TrainerInvitesAvailable"
                                            type="number"
                                            invalidcharacter={[" "]}
                                            placeholder="profile_label_trainer_invitations_available"
                                            as={FormikFormInput}
                                        />
                                    </div>
                            }

                            <div className="form-group d-flex justify-content-between align-items-start">
                                <Label
                                    required={true}
                                    label="profile_label_agent"
                                    htmlFor="IsAgent"
                                />
                                <span className="form-switch">
                                    <Field
                                        data-testid="testIsAgent"
                                        className="form-check-input"
                                        role="switch"
                                        name="IsAgent"
                                        type="checkbox"
                                        id="inlineFormCheck"
                                        as={FormikFormCheckBox}
                                    />
                                </span>
                            </div>
                        </div>
                    </Form>
                    </>
                    )}
                </Formik>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
                <div>
                </div>
                <div className=" ">
                    <Button
                        data-testid="Cancel"
                        variant="secondary"
                        onClick={props.modalClosed}
                        disabled={props.isLoading}
                        className="btnOkSize me-2">
                        <FormattedMessage id="button_cancel" />
                    </Button>
                    <LoaderButton
                        type="submit"
                        variant="primary"
                        form="edit-profile-form"
                        id="RegisterButton"
                        className="btnOkSize"
                        isLoading={props.isLoading}
                        text="Update"
                    />
                </div>
            </Modal.Footer>
        </Modal>
        </>
    );
};

export default EditProfileForm;
